import { Amplify } from "aws-amplify";
import {
  signUp,
  SignUpOutput,
  confirmSignUp,
  ConfirmSignUpOutput,
  SignInOutput,
  signIn,
  signOut,
  signInWithRedirect,
} from "aws-amplify/auth";
import { Hub } from "aws-amplify/utils";

Hub.listen("auth", (data) => {
  console.log({ data });
});

const manifestTest = {
  userPoolId: "us-east-1_mp8uaTDqM",
  userPoolClientId: "5quri628chnvusj1oiue0qr873",
};
Amplify.configure({
  Auth: {
    Cognito: {
      ...manifestTest,
      loginWith: {
        oauth: {
          domain: "us-east-1mp8uatdqm.auth.us-east-1.amazoncognito.com",
          providers: ["Google"],
          scopes: ["openid", "email", "profile"],
          redirectSignIn: ["http://localhost:3001/redirect/auth", "https://dev.dev-manifest.com/redirect/auth"],
          redirectSignOut: ["http://localhost:3001/", "https://dev.dev-manifest.com/"],
          responseType: "code",
        },
      },
    },
  },
});

export const newSignUp = async (params: any): Promise<SignUpOutput | undefined> => {
  console.log({ params });
  const { firstName, lastName, phoneNumber } = params;
  try {
    const res = await signUp({
      username: params.email,
      password: params.password,
      options: {
        userAttributes: {
          family_name: lastName,
          given_name: firstName,
          phone_number: phoneNumber,
          "custom:partner": params.partner,
          "custom:currentEmployee": params.currentEmployee,
        },
      },
    });
    console.log({ res });
    return res;
  } catch (e) {
    console.log({ e });
  }
};

export const confirmCode = async (params: { username: string; code: string }): Promise<ConfirmSignUpOutput> => {
  const { username, code } = params;
  return await confirmSignUp({
    username,
    confirmationCode: code,
  });
};

export const newSignIn = async (params: { username: string; password: string }): Promise<SignInOutput | any> => {
  const { username, password } = params;
  await signOut();

  return signIn({
    username,
    password,
  });
};

export const signUpWithGoogle = async () => {
  await signOut();
  try {
    await signInWithRedirect({
      provider: "Google",
      customState: `partner=brose&currentEmployee=true`,
    });
  } catch (e) {
    console.error(e);
  }
};
